doulaeasy.init_job_count_slider = function(init_from_input, onchange_callback) {

    var change_callback = function(event, ui) {
        // track select requested hourly salary (only if Google Analytics is loaded)
        if (typeof ga !== 'undefined') {
            ga('send', 'event',  'home search: requested min job count', 'selected', 'amount', $('#requested_min_job_count').val());
            ga('send', 'event',  'home search: requested max job count', 'selected', 'amount', $('#requested_max_job_count').val());
        }

        $('#search_bar_form').submit();
    }

  var update_job_count_text = function(min, max) {
    var min_smaller = (min == doulaeasy.min_job_count ) ? '' : '';
    var max_bigger = (max == doulaeasy.max_job_count ) ? doulaeasy.job_count_text['bigger_than'] : '';
    var new_range = doulaeasy.job_count_text['need_past_experience'] + min + min_smaller + " " + doulaeasy.job_count_text['times'] + " " + doulaeasy.job_count_text['to']  + max +  doulaeasy.job_count_text['times'] + max_bigger;
    $("#job_count_range" ).html( new_range );
    $('#requested_min_job_count').val(min);
    $('#requested_max_job_count').val(max);
  }

  $(function() {
    var sliderElement = document.getElementById('slider-range-job-count');

    // Check if element exists
    if (!sliderElement) {
      console.warn('Job count slider element not found');
      return;
    }

    // Get initial values from hidden inputs
    var min = $('#requested_min_job_count').val();
    var max = $('#requested_max_job_count').val();
    var initMin = (min !== '' && min !== undefined) ? parseInt(min) : doulaeasy.min_job_count;
    var initMax = (max !== '' && max !== undefined) ? parseInt(max) : doulaeasy.max_job_count;
    var isSelected = (min !== '' && max !== '');

    // Destroy existing slider if it exists (for re-initialization)
    if (sliderElement.noUiSlider) {
      sliderElement.noUiSlider.destroy();
    }

    // Create the noUiSlider
    noUiSlider.create(sliderElement, {
      start: [initMin, initMax],
      connect: true,
      range: {
        'min': doulaeasy.min_job_count,
        'max': doulaeasy.max_job_count
      },
      step: 1,
      format: {
        to: function(value) { return Math.round(value); },
        from: function(value) { return Number(value); }
      }
    });

    // Update text and hidden inputs on slide
    sliderElement.noUiSlider.on('slide', function(values, handle) {
      var min = parseInt(values[0]);
      var max = parseInt(values[1]);
      update_job_count_text(min, max);
    });

    // Fire callback on change (when user releases the slider)
    sliderElement.noUiSlider.on('change', function(values, handle) {
      var min = parseInt(values[0]);
      var max = parseInt(values[1]);

      if (onchange_callback) {
        // Pass data in jQuery UI format for backward compatibility
        onchange_callback({}, { values: [min, max] });
      } else {
        change_callback({}, { values: [min, max] });
      }
    });

    // Initial text update
    if (!isSelected) {
      $("#job_count_range").html(
        doulaeasy.job_count_text['need_past_experience'] + '-' + " " +
        doulaeasy.job_count_text['times'] + " " +
        doulaeasy.job_count_text['to'] + " -" + " " +
        doulaeasy.job_count_text['times'] +
        (doulaeasy.max_job_count == initMax ? doulaeasy.job_count_text['bigger_than'] : '')
      );
    } else {
      update_job_count_text(initMin, initMax);
    }
  });
}

doulaeasy.init_hourly_salary_slider = function(init_from_input, onchange_callback) {

    var change_callback = function() {
        // track select requested hourly salary (only if Google Analytics is loaded)
        if (typeof ga !== 'undefined') {
            ga('send', 'event',  'home search: requested min hourly salary', 'selected', 'amount', $('#requested_min_hourly_salary').val());
            ga('send', 'event',  'home search: requested max hourly salary', 'selected', 'amount', $('#requested_max_hourly_salary').val());
        }

        $('#search_bar_form').submit();
    }

  var update_hourly_salary_text = function(min, max) {
    var min_smaller = (min == doulaeasy.min_hourly_salary ) ? '' : '';
    var max_bigger = (max == doulaeasy.max_hourly_salary ) ? doulaeasy.hourly_salary_text['bigger_than'] : '';
    var new_range = doulaeasy.hourly_salary_text['willing_to_pay_hourly_salary'] + min + min_smaller + " " + doulaeasy.hourly_salary_text['to'] + " $" + max + max_bigger;
    $("#hourly_salary_range" ).html( new_range );
    $('#requested_min_hourly_salary').val(min);
    $('#requested_max_hourly_salary').val(max);
  };

  $(function() {
    var sliderElement = document.getElementById('slider-range-hourly-salary');

    // Check if element exists
    if (!sliderElement) {
      console.warn('Hourly salary slider element not found');
      return;
    }

    // Get initial values from hidden inputs
    var min = $('#requested_min_hourly_salary').val();
    var max = $('#requested_max_hourly_salary').val();
    var initMin = (min !== '' && min !== undefined) ? parseInt(min) : doulaeasy.min_hourly_salary;
    var initMax = (max !== '' && max !== undefined) ? parseInt(max) : doulaeasy.max_hourly_salary;
    var isSelected = (min !== '' && max !== '');

    // Destroy existing slider if it exists (for re-initialization)
    if (sliderElement.noUiSlider) {
      sliderElement.noUiSlider.destroy();
    }

    // Create the noUiSlider
    noUiSlider.create(sliderElement, {
      start: [initMin, initMax],
      connect: true,
      range: {
        'min': doulaeasy.min_hourly_salary,
        'max': doulaeasy.max_hourly_salary
      },
      step: 1,
      format: {
        to: function(value) { return Math.round(value); },
        from: function(value) { return Number(value); }
      }
    });

    // Update text and hidden inputs on slide
    sliderElement.noUiSlider.on('slide', function(values, handle) {
      var min = parseInt(values[0]);
      var max = parseInt(values[1]);
      update_hourly_salary_text(min, max);
    });

    // Fire callback on change (when user releases the slider)
    sliderElement.noUiSlider.on('change', function(values, handle) {
      var min = parseInt(values[0]);
      var max = parseInt(values[1]);

      if (onchange_callback) {
        // Pass data in jQuery UI format for backward compatibility
        onchange_callback({}, { values: [min, max] });
      } else {
        change_callback();
      }
    });

    // Initial text update
    if (!isSelected) {
      $("#hourly_salary_range").html(
        doulaeasy.hourly_salary_text['willing_to_pay_hourly_salary'] + '-' + " " +
        doulaeasy.hourly_salary_text['to'] + " $-" +
        (doulaeasy.max_hourly_salary == initMax ? doulaeasy.hourly_salary_text['bigger_than'] : '')
      );
    } else {
      update_hourly_salary_text(initMin, initMax);
    }
  });
}
